<template>
  <div id="app" class="ls-height-inherit">
    <component :is="layout">
    </component>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import store from 'src/vuex'

  export default {
    name: 'app',
    store: store,
    computed: {
      ...mapGetters(['currentUser', 'isLogged']),
      isAuthenticated () {
        return this.isLogged
      },
      wizardDone () {
        return this.currentUser.wizard_done
      },
      layout () {
        let layout = 'admin'
        if (this.$route.meta && this.$route.meta.layout) {
          layout = this.$route.meta.layout
        }
        return layout + '-layout'
      }
    }
  }
</script>

<style lang="scss">
  .ls-display-flex {
    display: flex;
  }
  .ls-no-outline {
    background: none;
    box-shadow: none;
    outline: 0;
  }
  .ls-box-body {
    strong {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .ls-label-text-prefix {
    border: 1px solid #ddd;
    color: #a2a2a2;
    min-width: 48px;
  }
  .ls-error {
    .ls-custom-select {
      border-color: #d75553;
      &:after {
        border-color: #d75553;
      }
      &:before {
        border-color: #d75553 transparent transparent transparent;
      }
    }
    > .ls-label-text-prefix {
      border: 1px solid blue!important;
    }
    ::-webkit-input-placeholder {
      color: #d75553;
    }
    ::-moz-placeholder {
      color: #d75553;
    }
  }
  .ls-board-box .ls-box .ls-box-head {
    font-family: Open Sans;
    font-size: 14px;
  }
  .ls-board-box .ls-box .ls-box-body strong {
    font-family: Open Sans;
    font-size: 32px;
    line-height: 2;
  }
  @media (max-width: 468px) {
    .ls-table.ls-sm-space th, .ls-table.ls-sm-space td, .ls-btn-xs, .ls-table th, .ls-table td {
      font-size: 10px !important;
    }
  }
  @media (max-width: 970px){
    .ls-btn a {
      display: none !important;
    }
  }
  .ls-main {
    -moz-transform: none;
    -ms-transform: none;
    -webkit-transform: none;
    transform: none;
  }
  .ls-main-full {
    z-index: 9;
    position: relative;
    padding-top: 70px;
  }
  .input-error {
    b {
      color: #d75553!important;
    }
    .ls-label-text-prefix {
      border-width: 1px 1px 1px 0px;
      border-style: solid;
      border-color: #d75553!important;
      color: #d75553!important;
    }
    input {
      border: 1px solid #d75553!important;
      border-left-width: 0!important;
    }
    .help-message {
      color: #d75553;
      font-size: 12px;
    }
    .icon {
      fill: #d75553;
    }
    .ls-custom-select {
      border-color: #d75553;
      color: #d75553;
      &:before {
        border-color: #d75553 transparent transparent transparent;
      }
      &:after {
        border-left: 1px solid #d75553;
      }
    }
  }
  .ls-box-filter {
    .btn-action {
      float: right;
      padding: 0 15px;
      margin: 0!important;
      @media screen and (max-width: 480px) {
        float: none;
        button, a {
          width: 100%;
          display: block;
          margin: 0 0 10px 0!important;
          &:last-child {
            margin: 0!important;
          }
        }
      }
    }
  }
  input[type="date"] {
    -webkit-appearance: none;
    padding: 12px 10px;
    display: inline-block;
    background: white;
    font-size: 14px;
    color: #555555;
    width: 100%;
    z-index: 1;
    -webkit-box-shadow: inset,0 1px 1px,rgba(0,0,0,0.075);
    -moz-box-shadow: inset,0 1px 1px,rgba(0,0,0,0.075);
    -ms-box-shadow: inset,0 1px 1px,rgba(0,0,0,0.075);
    -o-box-shadow: inset,0 1px 1px,rgba(0,0,0,0.075);
    box-shadow: inset,0 1px 1px,rgba(0,0,0,0.075);
  }
  .v-select {
    .dropdown-toggle {
      position: relative;
      font-size: 13px;
      background: white!important;
      border: 1px solid rgb(222, 222, 222)!important;
      padding-right: 28px!important;
      input[type=search] {
        height: 33px!important;
        border-right: 1px solid #ddd!important;
        border-radius: 0!important;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 100%!important;
        border-right: 1px solid #dedede;
        &:focus {
          background: #fff;
        }
      }
      .selected-tag {
        left: 0;
        background: none;
        border: none;
        position: absolute;
        width: calc(100% - 34px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
      }
    }
    .open-indicator {
      display: none!important;
    }
    &:before {
      content: "";
      width: 0;
      height: 0;
      margin-left: 5px;
      border-style: solid;
      border-width: 5px;
      border-color: #555555 transparent transparent transparent;
      position: absolute;
      top: 50%;
      margin-top: -2px;
      right: 10px;
      z-index: 2;
      pointer-events: none;
    }
  }
</style>



// WEBPACK FOOTER //
// Main.vue?418eda77